import { render } from "./moh732.vue?vue&type=template&id=6c7a4fea&scoped=true"
import script from "./moh732.vue?vue&type=script&lang=js"
export * from "./moh732.vue?vue&type=script&lang=js"

import "./moh732.vue?vue&type=style&index=0&id=6c7a4fea&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7a4fea"]])

export default __exports__